import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { catchError, of } from 'rxjs';
import { MinisitiResDto } from '../../../api/models';
import { OrganizzazioneService } from './organizzazione.service';

@Injectable({ providedIn: 'root' })
export class OrganizzazioneResolver implements Resolve<MinisitiResDto | null> {
  private service = inject(OrganizzazioneService);

  resolve(route: ActivatedRouteSnapshot) {
    const slug = route.paramMap.get('orgSlug')!;

    return this.service.getOrganizzazione(slug).pipe(catchError((err) => of(null)));
  }
}
